// DinamicX 相关业务层
import * as Dinamic from '@ali/dinamic';
import '@ali/dinamic-views-icbu-fork';
import { getClickSPMFromTraceInfo, addClickSPMToURL, appUrlAdaptive } from '../../freeblock';
import { handlerUrlFormat } from '../../common/utils'; // 事件： link 点击  ？？？ 作用

Dinamic.registerEventHandler('link', args => {
  const data = args[0];
  let url = data.action;

  if (url && url.length > 0) {
    // 0. 链接检查
    url = appUrlAdaptive(url); // 1. URL 追加 spm

    const clickSPM = getClickSPMFromTraceInfo(data.traceInfo);
    url = addClickSPMToURL(url, clickSPM); // 2. URL domain 替换/参数追加（场馆性能优化）

    url = handlerUrlFormat(url);
  } else {
    console.error('DX Click - URL 为空...', args);
  }
});